// import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';

// const Header = () => {
//   const [isNavCollapsed, setIsNavCollapsed] = useState(true);
//   const [isSticky, setIsSticky] = useState(false); // 👈 for sticky on scroll

//   const handleNavClick = () => {
//     setIsNavCollapsed(true);
//   };

//   // 👇 Add scroll event listener
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 50) {
//         setIsSticky(true);
//       } else {
//         setIsSticky(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <header className={`sticky ${isSticky ? 'sticky-active' : ''}`}>
//       <Navbar expand="lg" bg="dark" variant="dark" fixed="top" className="p-0">
//         <Container className="main-header">
//           <Navbar.Brand as={Link} to="/"><img src="/assets/img/logo.png" className="logo-icon" alt=""/>Freelity</Navbar.Brand>
//           <Navbar.Toggle aria-controls="navbar-nav" onClick={() => setIsNavCollapsed(!isNavCollapsed)} />
//           <Navbar.Collapse id="navbar-nav" className={`${isNavCollapsed ? 'collapse' : ''}`}>
//             <Nav className="under-list">
//               <Nav.Link as={Link} to="/" onClick={handleNavClick}>Home</Nav.Link>
//               <NavDropdown title="All Tools" id="navbar-dropdown">
//                 <NavDropdown.Item as={Link} to="/html-formatter" onClick={handleNavClick}>Html Formatter</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/css-formatter" onClick={handleNavClick}>Css Formatter</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/javascript-formatter" onClick={handleNavClick}>Javascript Formatter</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/json-formatter" onClick={handleNavClick}>Json Formatter</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/age-calculator" onClick={handleNavClick}>Age Calculator</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/word-counter" onClick={handleNavClick}>Word Counter</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/bmi-calculator" onClick={handleNavClick}>BMI Calculator</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/qr-code-generator" onClick={handleNavClick}>QR Code Generator</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/text-case-converter" onClick={handleNavClick}>Text Case Converter</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/password-generator" onClick={handleNavClick}>Password Generator</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/lorem-ipsum-generator" onClick={handleNavClick}>Lorem Ipsum Generator</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/color-picker" onClick={handleNavClick}>Color Picker</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/youtube-thumbnail-downloader" onClick={handleNavClick}>Youtube Thumbnail Downloader</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/meta-tag-generator" onClick={handleNavClick}>Meta Tag Generator</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/online-stopwatch-timer" onClick={handleNavClick}>Online Stopwatch Timer</NavDropdown.Item>
//                 <NavDropdown.Item as={Link} to="/countdown-timer" onClick={handleNavClick}>Countdown Timer</NavDropdown.Item>
//               </NavDropdown>
//               <Nav.Link as={Link} to="/about" onClick={handleNavClick}>About</Nav.Link>
//               <Nav.Link as={Link} to="/contact" onClick={handleNavClick}>Contact Us</Nav.Link>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//     </header>
//   );
// };

// export default Header;




import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';

const Header = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [isSticky, setIsSticky] = useState(false); // 👈 for sticky on scroll

  const handleNavClick = () => {
    setIsNavCollapsed(true);
  };

  // 👇 Add scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`sticky ${isSticky ? 'sticky-active' : ''}`}>
      <Navbar expand="lg" bg="dark" variant="dark" fixed="top" className="p-0">
        <Container className="main-header">
          <Navbar.Brand as={Link} to="/"><img src="/assets/img/logo.png" className="logo-icon" alt=""/>Freelity</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" onClick={() => setIsNavCollapsed(!isNavCollapsed)} />
          <Navbar.Collapse in={!isNavCollapsed} id="navbar-nav">
            <Nav className="under-list">
              <Nav.Link as={Link} to="/" onClick={handleNavClick}>Home</Nav.Link>
              <NavDropdown title="All Tools" id="navbar-dropdown">
                <NavDropdown.Item as={Link} to="/html-formatter" onClick={handleNavClick}>Html Formatter</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/css-formatter" onClick={handleNavClick}>Css Formatter</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/javascript-formatter" onClick={handleNavClick}>Javascript Formatter</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/json-formatter" onClick={handleNavClick}>Json Formatter</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/age-calculator" onClick={handleNavClick}>Age Calculator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/word-counter" onClick={handleNavClick}>Word Counter</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/bmi-calculator" onClick={handleNavClick}>BMI Calculator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/qr-code-generator" onClick={handleNavClick}>QR Code Generator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/text-case-converter" onClick={handleNavClick}>Text Case Converter</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/password-generator" onClick={handleNavClick}>Password Generator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/lorem-ipsum-generator" onClick={handleNavClick}>Lorem Ipsum Generator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/color-picker" onClick={handleNavClick}>Color Picker</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/youtube-thumbnail-downloader" onClick={handleNavClick}>Youtube Thumbnail Downloader</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/meta-tag-generator" onClick={handleNavClick}>Meta Tag Generator</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/online-stopwatch-timer" onClick={handleNavClick}>Online Stopwatch Timer</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/countdown-timer" onClick={handleNavClick}>Countdown Timer</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link as={Link} to="/about" onClick={handleNavClick}>About</Nav.Link>
              <Nav.Link as={Link} to="/contact" onClick={handleNavClick}>Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
